import React, { useState, useMemo, useContext } from "react";
import { Toast } from "../UI/toast/Toast";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import PageHeader from "../common/PageHeader";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useParams, useHistory } from "react-router";
import { Link } from "react-router-dom";
import { Alert } from "reactstrap";
import { fetchProviders } from "../../helpers/api/provider";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import { PreloadState } from "../UI/preloading/PreloadState";
import SupportLink from "../root/support/components/SupportLink";
import { fetchCreateCommonCost } from "../../helpers/api/finance";
import { useSelector } from "react-redux";
import { fetchProperties } from "../../helpers/api/condominium";
import CreateAccountPayForm from "./CreateAccountPayForm";
import { CurrencyContext } from "../../context/Context";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const CreateAccountPay = ({ setRedirectUrl, setRedirect }) => {
  const moduleBase = useModuleBase();

  const { id } = useParams();
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { currency: curr } = useContext(CurrencyContext);
  const activeExchangeRate = Number(curr?.value ?? 0);
  const params = useMemo(() => ({
    condominiumId: id || selectedCondominium,
  }), [id, selectedCondominium]);
  const history = useHistory();
  const {
    mutate,
    data,
    isLoading,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(fetchProviders, params);

  const properties = useSWRFetchPagination(fetchProperties, params);

  const create = async (values) => {
    try {
      const { code } = await fetchCreateCommonCost(
        id || selectedCondominium,
        {
          ...values,
          ...(activeExchangeRate ? { rate: activeExchangeRate } : {}),
          type_id: 4,
        }
      );
      if (code === SUCCESS_RESPONSE.SUCCESFUL) {
        history.push({
          pathname: `/dashboard/${moduleBase}/${id}/topay`,
        });

        Toast.fire({
          type: "success",
          title: `Cuenta por pagar registrada exitosamente.`,
        });
      }
    } catch (error) {
      console.log(error);
      handleErrorMessage(error);
    }
  };

  return (
    <>
      <PageHeader
        title="Cuenta por pagar"
        titleTag="h2"
        description="Asigna un gasto comun a un proveedor."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <Alert color="warning" className="shadow-sm">
        <p className="mb-0">
          Las cuentas por pagar registradas aquí no se verán reflejadas en la
          planilla de liquidación de gastos. Si necesitas que un gasto aparezca
          en la planilla, regístralo en el{" "}
          <Link to={`/dashboard/finance/${id || selectedCondominium}?section=expenses`}>
            módulo de gastos
          </Link>
          .
        </p>
      </Alert>
      <PreloadState loading={isLoading}>
        <CreateAccountPayForm
          handleSubmitData={create}
          mutate={mutate}
          handler={{ nextPage, previousPage, perPage, goToPage, meta }}
          handlerM={properties.handler}
          providers={data}
          metaa={properties.meta}
          properties={properties.data}
        />
      </PreloadState>
    </>
  );
};

export default withRedirect(CreateAccountPay);
